import { SCAN_UI_CONTEXT_REGISTRY } from '../constants/scanUiContextRegistry.const';
import { type CreateScanContextOptions, type ScanContext } from '../types/scanContext.type';
import { resolveScanRouteContext } from './resolveScanRouteContext.util';

export const createScanContext = ({
  getUiContext = SCAN_UI_CONTEXT_REGISTRY.snapshot,
  pathname = window.location.pathname,
}: CreateScanContextOptions = {}): ScanContext => ({
  route: resolveScanRouteContext(pathname),
  ui: getUiContext(),
});
